var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 16,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 36H5C4.73478 36 4.48043 35.8946 4.29289 35.7071C4.10536 35.5196 4 35.2652 4 35V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H20V6H6V34H34V21H36V35C36 35.2652 35.8946 35.5196 35.7071 35.7071C35.5196 35.8946 35.2652 36 35 36Z",
    fill: "#99BA14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22C20.8684 22.0008 20.738 21.9756 20.6161 21.9258C20.4943 21.876 20.3835 21.8027 20.29 21.71L14.29 15.71L15.7 14.3L21 19.59L34.29 6.29004L35.7 7.70004L21.7 21.7C21.5154 21.8885 21.2638 21.9963 21 22Z",
    fill: "#99BA14"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-list.c7e1d3c559af8ea98f90d71bf06e6aa8.svg";